import { Authority } from '@/shared/security/authority';

import MyPage from '@/v2/my-page/my-page/my-page.vue';
import MyPageDetail from '@/v2/my-page/detail/my-page-detail.vue';
import MyPagePreview from '@/v2/my-page/preview/my-page-preview.vue';
import PaymentHistory from '@/v2/my-page/payment-history/payment-history.vue';
import InviteFriend from '@/v2/my-page/invite-friend/invite-friend.vue';
import MyPageEdit from '@/v2/my-page/edit/my-page-edit.vue';
import MyPageDelete from '@/v2/my-page/delete/my-page-delete.vue';
import MyPageReset from '@/v2/my-page/reset/my-page-reset.vue';
import MyPageSetting from '@/v2/my-page/setting/my-page-setting.vue';
import CollectionChannel from '@/v2/my-page/collection-channel/collection-channel.vue';

export default [
  {
    path: '/my-page',
    name: 'UserMyPageComponent',
    component: MyPage,
    children: [
      { path: '', name: 'MyPagePreview', component: MyPagePreview, meta: {} },
      {
        path: 'detail',
        name: 'MyPageDetail',
        component: MyPageDetail,
        children: [
          { path: '', name: 'MyPageEdit', component: MyPageEdit, meta: { authorities: [Authority.USER] } },
          { path: 'delete', name: 'MyPageDelete', component: MyPageDelete, meta: { authorities: [Authority.USER] } },
          { path: 'reset', name: 'MyPageReset', component: MyPageReset, meta: { authorities: [Authority.USER] } },
        ],
      },
      { path: 'payment-history', name: 'PaymentHistory', component: PaymentHistory, meta: { authorities: [Authority.USER] } },
      { path: 'invite-friend', name: 'InviteFriend', component: InviteFriend, meta: { authorities: [Authority.USER] } },
      {
        path: 'collection-channel',
        name: 'ManageCollectionChannel',
        component: CollectionChannel,
        meta: { authorities: [Authority.USER] },
      },
      { path: 'setting', name: 'UserSetting', component: MyPageSetting },
    ],
  },
];
